import { render } from "./ProofUpload.vue?vue&type=template&id=eede056c&scoped=true"
import script from "./ProofUpload.vue?vue&type=script&lang=js"
export * from "./ProofUpload.vue?vue&type=script&lang=js"

import "./ProofUpload.vue?vue&type=style&index=0&id=eede056c&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eede056c"]])

export default __exports__